import React from "react";
import { Controller } from "react-hook-form";
import get from "lodash/get";
import clsx from "clsx";
import { StyledInputNumber } from "./InputNumber.style";
import { NumericFormat } from "react-number-format";

const InputNumeric = (props, ref) => {
  const {
    name,
    control,
    normalizes,
    mask,
    thousandSeparator = false,
    ...rest
  } = props;

  const onChangeHandler =
    ({ onChange }) =>
    (e) => {
      const val = e.target.value.replace(/[^0-9.]/g, "");

      const isPassRule =
        (normalizes && normalizes.every((normalize) => normalize(val))) ?? true;
      if (val && !isPassRule) {
        return;
      }
      onChange(val);
    };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, formState: { errors } }) => {
        const errorMsg = get(errors, `${name}.message`, undefined);

        return (
          <>
            <StyledInputNumber
              as={NumericFormat}
              className={clsx({
                "disabled:bg-quarternary disabled:border-quarternary":
                  rest?.disabled,
                "!border-vekin-message-error": Boolean(errorMsg),
              })}
              name={field.name}
              value={field.value}
              onChange={onChangeHandler({ onChange: field.onChange })}
              {...rest}
              //   ref={ref}
              onKeyDown={(e) =>
                ["e", "E", "+", "-", "ArrowUp", "ArrowDown"]?.includes(e.key) &&
                e?.preventDefault()
              }
              onWheel={(e) => e.target.blur()}
              thousandSeparator={thousandSeparator}
            />

            {errorMsg ? (
              <label className="label !py-1 text-vekin-message-error">
                <span className="label-text-alt text-vekin-message-error">
                  {errorMsg}
                </span>
              </label>
            ) : null}
          </>
        );
      }}
    />
  );
};

InputNumeric.displayName = "Input";

export default InputNumeric;
